

































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import { vxm } from '@/store';
import { CreateRepositoryInfoDto } from '@/@types/theoryGit/repositoryInfo';

@Component({
  components: {
    CommonButton,
  },
})
export default class CreateReposiotryModal extends Vue {
  @Prop({ required: true })
  private isOpenCreateRepositoryModal!: boolean;
  private commonButtonColorClose: string = '#359cf3';
  private repositoryName = '';
  private repositoryDetail: string | null = null;

  private async onCreateRepository() {
    const params: CreateRepositoryInfoDto = {
      repositoryName: this.repositoryName,
      repositoryDetail: this.repositoryDetail,
      projectId: this.projectId,
    };
    this.createRepository(params);
  }

  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId ?? 0;
  }

  @Emit('createRepository')
  private createRepository(params: CreateRepositoryInfoDto) {
    return params;
  }

  @Emit('closeCreateRepositoryModal')
  private closeCreateRepositoryModal() {}
}
